<template>
  <v-container>
    <v-row class="mb-4 justify-space-between">
    <v-col>
      <h1 class="text-h4 titulo">Familias</h1>
    </v-col>
    <v-col class="text-end">
      <v-btn class="ml-4" color="success" @click="update(-1)">
          <v-icon class="mr-2">fas fa-plus</v-icon>Nuevo
      </v-btn>
    </v-col>
  </v-row>
  <v-row justify-md="end">
    <v-col cols="12" md="6">
      <v-text-field
        v-model="search"
        label="Buscar"
        append-icon="fas fa-search"
        :disabled="loading"
      ></v-text-field>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-data-table
          class=""
          :headers="headers"
          :items="families"
          :items-per-page="10"
          :loading="loading"
          :search="search"
          sort-by='name'
          item-class="table-body"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-angle-double-left',
            lastIcon: 'fas fa-angle-double-right',
            prevIcon: 'fas fa-angle-left',
            nextIcon: 'fas fa-angle-right'
          }">
          <template v-slot:item.name="{ item }">
            {{item.name}}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon  class="mr-2" @click.stop="update(item.id)">fas fa-edit</v-icon>
            <!-- <v-icon class="error--text" @click.stop="deleteItem(item)">delete</v-icon> -->
          </template>
        </v-data-table>
    </v-col>
  </v-row>
  <v-dialog v-model="showDialog" max-width="500">
    <v-card class="px-10 py-4">
      <family-create-update  
      :id="family"
      @updated="fetch"
      @close="showDialog=false"
      />
    </v-card>
  </v-dialog>
  </v-container>
</template>

<script>
import {fetchFamilies} from '@/api/stocks'
import notifications from '@/utils/notifications'
import FamilyCreateUpdate from '@/components/stocks/FamilyCreateUpdate'

export default {
  name:'Families',
  components:{FamilyCreateUpdate},
  data() {
    return {
      loading: false,
      family:'',
      families:[],
      search:'',
      total:'',
      showDialog:false,
      headers: [
      {
        text: 'Item',
        align: 'start',
        value: 'id',
        class: 'table-header'
      },
      {
        text: 'Nombre',
        align: 'start',
        value: 'name',
        class: 'table-header'
      },
      
      { text: 'Acciones',value:'actions',class: 'table-header',align:'center',sortable: false}
    ],
    }
  },
  methods:{
    async fetch(){
      this.loading=true
      await fetchFamilies()
      .then(res=>{
        this.families=res
      })
      .catch((err)=>{
        notifications.showError('Error cargando familias '+err)
      })
      this.loading=false
    },
    update(item){
      this.family=item
      this.showDialog=true
    }
  },
  watch:{
    
  },
  async mounted(){
    
    this.fetch()
    
  }
}
</script>

<style>

</style>